export enum ADD_CANDIDATE_FORM_STEP {
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
}

export interface PreviousAttachment {
  prospectId: string;
  attachmentId: string;
  fileName: string;
}

export interface CandidateAttachment {
  file: File | null;
  previousAttachment: PreviousAttachment | null;
  isValid: boolean;
}

interface CandidateDetails {
  id: number;
  email: string;
  firstName: string | null;
  lastName: string | null;
  phone: string | null;
  mostRecentJobTitle?: string | null;
  mostRecentCompanyName?: string | null;
  timeInRoleYears?: string | null;
  timeInRoleMonths?: string | null;
  isNewToWorkforce?: boolean | null;
  previousResume?: PreviousAttachment | null;
  previousCoverLetter?: PreviousAttachment | null;
}

interface MostRecentApplication {
  dateApplied: string;
  jobTitle: string;
  alreadyAppliedForThisPosition: boolean;
}

export interface CandidatePreviousApps {
  candidateDetails: CandidateDetails | null;
  mostRecentApplication: MostRecentApplication | null;
}
